@let preventLogin = $preventLogin();
<!--{}-->

@if(!environment?.production || isSuperUserAndProduction || preventLogin) {
    <div class="shell-top-filler" [class.super-admin]="isSuperUserAndProduction || preventLogin"></div>
}

@if (inlineSideNavEnabled) {
    <inline-side-nav [toggle]="$safeNavigationMigration(state?.navExpanded)" [state]="state" />
} @else {
    <side-nav class="modern nav" [toggle]="$safeNavigationMigration(state?.navExpanded)" [state]="state"></side-nav>
}

<div class="shell" [ngClass]="{expanded: $safeNavigationMigration(state?.navExpanded)}">

    <!-- <div class="shell-top">
        <div id="shell-page-actions-container" class="page-actions-container">
            <ng-container *ngIf="!environment.production">Environment: {{environment.environment}}</ng-container>
        </div>
        <div class="notifications">

        </div>
        <div class="notifications">

            <p-menu #menu [model]="menuItems" [popup]="true" [style]="{'margin-top': '5px'}" appendTo="body"> </p-menu>
            <profile (click)="menu.toggle($event)" [userImageUrl]="state?.user?.image" [userName]="state?.user?.name" [size]="25"></profile>

        </div>
    </div> -->

    @if(!environment?.production || isSuperUserAndProduction || preventLogin) {

        <div class="shell-top" [class.super-admin]="isSuperUserAndProduction || preventLogin">
            @if (preventLogin) {
                ***<span class="environment">User Logins Disabled</span>***&nbsp;|&nbsp;
            }
            <span class="environment">Environment: {{friendlyEnvironment}}</span>&nbsp;|&nbsp;
            <span class="build">({{buildVersion}})</span>
        </div>

        }

        <div class="shell-content">
            <router-outlet #routerOutlet="outlet"></router-outlet>
        </div>


        <!-- Bottom Bar — agent-chat-footer replaces the old shell-bottom -->
        @if ($showBottomBar()) {
            <agent-chat-footer [tabs]="agentPanelService.$enrichedTabs()" [activeTabId]="agentPanelService.$activeTabId()" (tabActivated)="onAgentTabActivated($event)" (tabClosed)="onAgentTabClosed($event)" (newChat)="onAgentNewChat()" (threadSelected)="onAgentThreadSelected($event)" />
        }

</div>

<!-- Agent V2 Panel -->
@if ($showBottomBar()) {
    <div class="agent-panel-wrapper"
         [class.animate]="$panelAnimate()"
         [class.popup-mode]="agentPanelService.$displayMode() === 'popup'"
         [class.expanded-mode]="agentPanelService.$displayMode() === 'pseudo'"
         [class.panel-hidden]="!agentPanelService.$panelOpen() || !$panelPositionReady()"
         [class.panel-instant]="agentPanelService.$panelExitMode() === 'close'"
         [class.custom-rect]="$activePopupRect()"
         [class.window-interacting]="$windowInteracting()"
         [style.--sidenav-width.px]="$sidenavWidth()"
         [style.--footer-height.px]="$footerHeight()"
         [style.--shell-top-offset.px]="$shellTopOffset()"
         [style.top.px]="$activePopupRect()?.top"
         [style.left.px]="$activePopupRect()?.left"
         [style.width.px]="$activePopupRect()?.width"
         [style.height.px]="$activePopupRect()?.height">
        <agent-popup-chat [canReset]="$popupMoved()" [dragging]="$windowDragging()" (close)="onAgentPopupClose()" (dragStart)="onPopupDragStart($event)" (resetPosition)="onResetPopupPosition()" />

        <!-- Drag-to-resize handles: edges + corners. Windowed (popup) mode only. -->
        @if ($activePopupRect()) {
            <div class="agent-window-resize edge n" (pointerdown)="onResizeStart($event, 'n')"></div>
            <div class="agent-window-resize edge s" (pointerdown)="onResizeStart($event, 's')"></div>
            <div class="agent-window-resize edge e" (pointerdown)="onResizeStart($event, 'e')"></div>
            <div class="agent-window-resize edge w" (pointerdown)="onResizeStart($event, 'w')"></div>
            <div class="agent-window-resize corner ne" (pointerdown)="onResizeStart($event, 'ne')"></div>
            <div class="agent-window-resize corner nw" (pointerdown)="onResizeStart($event, 'nw')"></div>
            <div class="agent-window-resize corner se" (pointerdown)="onResizeStart($event, 'se')"></div>
            <div class="agent-window-resize corner sw" (pointerdown)="onResizeStart($event, 'sw')"></div>
        }
    </div>
}

<confirm />

<command-palette-host />

<p-toast styleClass="wb-toast" [baseZIndex]="10000" position="bottom-right">
    <ng-template let-message pTemplate="headless" let-closeFn="closeFn">

        @let severity = message.data?.severity ?? message.severity;

        <w-alert [closable]="!message?.sticky" displayStyle="toast" orientation="vertical" [severity]="severity" [summary]="message.summary" [detail]="message.detail" [actions]="$safeNavigationMigration(message.data?.actions)" (close)="closeFn($event)" />

    </ng-template>
</p-toast>